import { Injectable } from '@angular/core';
import { EnergyEfficiencyAttributes, Product } from '../models';
import { Attribute } from '~app/modules/product/models';

@Injectable({
  providedIn: 'root',
})
export class BuyAgainEnergyLabelService {
  constructor() {}

  public getEnergyEfficiencyLabelsV2(product: Product): EnergyEfficiencyAttributes {
    const energyAttr = this.getEnergyEfficiencyLabelConfig(product);
    if (!energyAttr) {
      return null;
    } else {
      const energyLabelConfigValue = this.getParsedEnergyLabelConfig(energyAttr);
      const eecLabel = this.getEnergyEfficiencyClassV2(energyLabelConfigValue?.defaultAttribute, product);
      const EECAttributes = {
        energyLabel: this.getEuEnergyLabel(product) || null,
        energyEfficiencyRange: {
          from: energyLabelConfigValue.range?.max || null,
          to: energyLabelConfigValue.range?.min || null,
        },
        energy_config: {
          energy_efficiency_label_config: energyLabelConfigValue,
          [energyLabelConfigValue?.defaultAttribute]: eecLabel,
        },
      };
      return EECAttributes;
    }
  }

  public getEnergyEfficiencyLabelValue(energyLabel: EnergyEfficiencyAttributes): string {
    if (!energyLabel) {
      return null;
    } else {
      const defaultAttribute = energyLabel?.energy_config?.energy_efficiency_label_config?.defaultAttribute;

      return energyLabel?.energy_config?.[defaultAttribute];
    }
  }

  private getParsedEnergyLabelConfig(energyLabelConfig: Attribute) {
    try {
      return energyLabelConfig ? JSON.parse(energyLabelConfig.value) : {};
    } catch (error) {
      return {};
    }
  }

  private getEnergyEfficiencyLabelConfig(product: Product): Attribute {
    return product?.attributes?.find((attribute) => attribute.code === 'energy_efficiency_label_config');
  }
  private getEnergyEfficiencyClassV2 = (defaultEnergyAttribute: string, productItem: Product): string => {
    return defaultEnergyAttribute
      ? productItem?.attributes?.find((attribute) => attribute.code === defaultEnergyAttribute)?.value
      : null;
  };
  private getEuEnergyLabel = (productItem: Product): string => {
    return productItem?.attributes?.find((attribute) => attribute.code === 'eu_energy_label')?.value;
  };
}
